import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Button, Modal, Typography } from 'antd';
import type { FC } from 'react';
import { IconEmail, IconWhatsApp } from 'src/components/Icon';

export interface Props {
  link: string;
  description?: string;
  isOpen?: boolean;
  onCancel?: () => void;
}
const { Text } = Typography;

export const ShareModal: FC<Props> = ({ link, description, isOpen, onCancel }) => {
  const emailBody = `${description ? `${description}\n\n` : ''}${link}`;
  const emailLink = `mailto:email@address.com?subject=Racemap%20shareable%20content&body=${encodeURIComponent(emailBody)}`;
  const whatsappMessage = `${description ? `${description}\n\n` : ''}${link}`;

  return (
    <Modal open={isOpen} onCancel={onCancel} title="Share" footer={null}>
      <Container>
        <StyledLink copyable ellipsis={true}>
          {link}
        </StyledLink>

        <ShareButtons>
          <Button shape={'circle'} href={emailLink} target="_blank" icon={<IconEmail />} />
          <Button
            shape={'circle'}
            href={`https://api.whatsapp.com/send?text=${encodeURIComponent(whatsappMessage)}`}
            target="_blank"
            icon={<IconWhatsApp />}
          />
        </ShareButtons>
      </Container>
    </Modal>
  );
};

const ShareButtons = styled.div`
  display: flex;
  gap: 0.5rem;
  padding-left: 1rem;
`;

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const StyledLink = styled(Text)`
  background-color:  ${RacemapColors.LightGray};
  font-family: 'Roboto Mono', monospace; 
  padding: 0.4rem 2rem 0.4rem 0.6rem;
  border-radius: 6px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  .ant-typography-copy {
    position: absolute;
    right: 120px; 
    top: 55%;
  }
`;
